import { render, staticRenderFns } from "./FiltrosUsuariosCliente.vue?vue&type=template&id=68936914&"
import script from "./FiltrosUsuariosCliente.vue?vue&type=script&lang=js&"
export * from "./FiltrosUsuariosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports